<template>
  <section>
    <aRow class="action-list" :gutter="[0, 20]">
      <aCol :span="24">
        <aAlert
          class="f12"
          type="info"
          banner
          :message="`As seguintes ações serão realizadas antes de ${salesAdditiveType} o produto: `"
        />
      </aCol>

      <aCol
        v-for="(action, index) in cancelActions"
        :key="index"
        :span="24"
        class="item"
      >
        <aRow :gutter="5">
          <aCol :span="2">
            <a-icon
              v-if="!action.loading"
              :type="action.done ? 'check' : ''"
              :class="['box', { check: action.done }]"
            />

            <a-icon v-if="action.loading" type="loading" class="box" />
          </aCol>
          <aCol :span="22">
            <span v-html="action.text"></span>
          </aCol>
        </aRow>
      </aCol>
    </aRow>

    <div class="a-center mt-20">
      <aDivider class="mb-20" />
      <aPopconfirm
        title="Tem certeza que deseja continuar?"
        ok-text="Sim"
        placement="top"
        cancel-text="Não"
        @confirm="onConfirmExecuteActions"
        :disabled="loadingSubmit"
      >
        <aButton
          type="danger"
          html-type="submit"
          :loading="loadingSubmit"
          :disabled="loadingSubmit"
        >
          {{
            loadingSubmit
              ? "Realizando ações, aguarde..."
              : `${salesAdditiveType} Produto`
          }}
        </aButton>
      </aPopconfirm>
    </div>
    <!-- <json-viewer
      :value="cancelActions"
      :show-array-index="false"
      :expand-depth="2"
    /> -->

    {{ productTotalValue }}
    {{ productToCancel.id }}

    <json-viewer
      :value="filterProductsFields()"
      :show-array-index="false"
      :expand-depth="2"
    />
  </section>
</template>

<script>
import formatThings from "@/mixins/general/formatThings";

export default {
  name: "ContractCancelModeModal",
  props: {
    tempContract: Object,
    contract: Object,
    allContractData: Object,
    cancelActions: Array,
    productValues: Object,
    cancelSpecificProducts: Boolean,
    disableCancelSale: Boolean,
    totalFees: Number,
    productTotalValue: Number,
    salesAdditiveType: String,
    product: String,
    productToCancel: Object,
    baseFinancesId: String,
    baseId: String,
  },
  mixins: [formatThings],
  data() {
    return {
      eventsList: [],
      invoicesList: [],
      loadingSubmit: false,
      cancelActionsLoading: false,
      loadingCancelSpecificProducts: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.verifyEventsAndInvoices();
    }, 2000);
  },
  methods: {
    isEmptyOrInvalid(value) {
      return value == undefined || value == null || value == "";
    },
    onClickOpenEvent(eventId) {
      window.open(`/events/calendar?oid=${eventId}`, "_blank");
    },
    onClickOpenInvoice(invoiceId) {
      window.open(`/financial/invoices?oid=${invoiceId}`, "_blank");
    },
    verifyEventsAndInvoices() {
      this.eventsList = [];
      this.invoicesList = [];

      const eventIds = new Set();
      const invoiceIds = new Set();

      const contractedServices = JSON.parse(
        this.tempContract.contracted_services
      );

      if (contractedServices.includes("hotel")) {
        const hotels = JSON.parse(this.tempContract["hotel_rows"]);
        for (const hotel of hotels) {
          const eventId =
            this.tempContract[`contract_finances_hotel_${hotel.id}_event_id`];
          const invoiceId =
            this.tempContract[`contract_finances_hotel_${hotel.id}_invoice_id`];

          if (!this.isEmptyOrInvalid(eventId) && !eventIds.has(eventId)) {
            this.eventsList.push({
              product: "hotel",
              productId: hotel.id,
              id: eventId,
              supplier:
                this.tempContract[
                  `contract_finances_hotel_${hotel.id}_supplier`
                ],
            });
            eventIds.add(eventId);
          }

          if (!this.isEmptyOrInvalid(invoiceId) && !invoiceIds.has(invoiceId)) {
            this.invoicesList.push({
              product: "hotel",
              productId: hotel.id,
              id: invoiceId,
              supplier:
                this.tempContract[
                  `contract_finances_hotel_${hotel.id}_supplier`
                ],
            });
            invoiceIds.add(invoiceId);
          }
        }
      }

      if (contractedServices.includes("flight")) {
        const flights = JSON.parse(this.tempContract["flight_sections_rows"]);
        for (const flight of flights) {
          const eventId =
            this.tempContract[`contract_finances_flight_${flight.id}_event_id`];
          const invoiceId =
            this.tempContract[
              `contract_finances_flight_${flight.id}_invoice_id`
            ];

          if (!this.isEmptyOrInvalid(eventId) && !eventIds.has(eventId)) {
            this.eventsList.push({
              product: "flight",
              productId: flight.id,
              id: eventId,
              supplier:
                this.tempContract[
                  `contract_finances_flight_${flight.id}_supplier`
                ],
            });
            eventIds.add(eventId);
          }

          if (!this.isEmptyOrInvalid(invoiceId) && !invoiceIds.has(invoiceId)) {
            this.invoicesList.push({
              product: "flight",
              productId: flight.id,
              id: invoiceId,
              supplier:
                this.tempContract[
                  `contract_finances_flight_${flight.id}_supplier`
                ],
            });
            invoiceIds.add(invoiceId);
          }
        }
      }

      if (contractedServices.includes("service")) {
        const services = JSON.parse(this.tempContract["service_rows"]);
        for (const service of services) {
          const eventId =
            this.tempContract[
              `contract_finances_service_${service.id}_event_id`
            ];
          const invoiceId =
            this.tempContract[
              `contract_finances_service_${service.id}_invoice_id`
            ];

          if (!this.isEmptyOrInvalid(eventId) && !eventIds.has(eventId)) {
            this.eventsList.push({
              product: "service",
              productId: service.id,
              id: eventId,
              supplier:
                this.tempContract[
                  `contract_finances_service_${service.id}_supplier`
                ],
            });
            eventIds.add(eventId);
          }

          if (!this.isEmptyOrInvalid(invoiceId) && !invoiceIds.has(invoiceId)) {
            this.invoicesList.push({
              product: "service",
              productId: service.id,
              id: invoiceId,
              supplier:
                this.tempContract[
                  `contract_finances_service_${service.id}_supplier`
                ],
            });
            invoiceIds.add(invoiceId);
          }
        }
      }
    },
    filterProductsFields() {
      let filteredFields = { active_tab: this.product };

      Object.keys(this.tempContract).forEach((key) => {
        if (
          key.startsWith(`hotel_rows`) ||
          key.startsWith(`${this.baseId}`) ||
          key.startsWith(`${this.baseFinancesId}`)
        ) {
          filteredFields[key] = this.tempContract[key];

          if (key === `${this.baseId}_total_price`) {
            filteredFields[key] = 0;
          }

          if (key === `${this.baseFinancesId}_profit_value`) {
            filteredFields[key] = -this.productTotalValue;
          }

          if (key === `${this.baseFinancesId}_net_value`) {
            filteredFields[key] = this.productTotalValue;
          }
        }
      });

      if (filteredFields[`hotel_rows`]) {
        const hotelRows = JSON.parse(filteredFields[`hotel_rows`]);
        let filteredHotelRows = hotelRows.filter(
          (hotel) => hotel.id === this.productToCancel.id
        );

        filteredHotelRows = filteredHotelRows.map((hotel) => {
          return { ...hotel, id: 1 };
        });

        filteredFields[`hotel_rows`] = JSON.stringify(filteredHotelRows);
      }

      let strFilteredFields = JSON.stringify(filteredFields);
      strFilteredFields = strFilteredFields.replace(
        new RegExp(`${this.product}_${this.productToCancel.id}`, "g"),
        `${this.product}_1`
      );

      filteredFields = JSON.parse(strFilteredFields);

      return filteredFields;
    },
    formatActionName() {
      if (this.salesAdditiveType === "Cancelar") {
        return {
          text: "Cancelado",
          altText: "Cancelamento",
        };
      }

      if (this.salesAdditiveType === "Alterar") {
        return {
          text: "Alterado",
          altText: "Alteração",
        };
      }
    },
    async onConfirmExecuteActions() {
      this.loadingSubmit = true;
      try {
        await this.processActions();
        setTimeout(() => {
          this.$emit("onFinishActions");
        }, 200);
      } catch (error) {
        console.error("Error:", error);
        this.$message.error("Ocorreu um erro ao realizar as ações.");
      } finally {
        this.loadingSubmit = false;
      }
    },
    async processActions() {
      for (const action of this.cancelActions) {
        action.loading = true;
        try {
          if (action.action === "create-credit-letter") {
            const data = await this.createCreditLetter();
            if (data) {
              action.done = true;
            } else {
              //break;
            }
          } else if (action.action === "create-contract") {
            await this.$http
              .post("/contract-v2/create", {
                customer_id: this.tempContract.customer_id,
                company_id: this.tempContract.company_id,
                company_branch_id: this.tempContract.company_branch_id,
                user: this.tempContract.user,
                id_infotera: this.tempContract.id_infotera,
                package_type: this.tempContract.package_type,
                status: "concluded",
                company: this.tempContract.company,
                opportunity_id: this.tempContract.opportunity_id,
                sale_id: 0,
                value: this.productTotalValue,
                value_to_pay: 0,
                taxes_value: 0,
                products_name: "",
                marketing_types: "",
                profit_value: -this.productTotalValue,
                profit_percentage: 0,
                financial_cost: 0,
                contracted_services: `['${this.product}']`,
                payment_methods: `[]`,
                first_checkin:
                  this.salesAdditiveType === "Cancelar"
                    ? this.tempContract.first_checkin
                    : "",
                last_checkout:
                  this.salesAdditiveType === "Cancelar"
                    ? this.tempContract.last_checkout
                    : "",
                release_date: this.formatMultiDatesEng({ _d: new Date() }),
                ...this.filterProductsFields(),
                modified_by: {
                  name: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}`,
                  id: this.$store.state.userData.id,
                },
              })
              .then(({ data }) => {
                action.done = true;

                this.$http.post("/log/createx", {
                  user_id: this.$store.state.userData.id,
                  module_id: this.tempContract.id,
                  module: "contract",
                  action: "create-cancellation-contract",
                  description: `<b>[ADITIVO DE VENDAS]</b> <font class="user">${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}</font> gerou um contrato de cancelamento <font class="id">ID ${data.id}</font> a partir do <font class="id">ID ${this.tempContract.id}</font>.`,
                });
              });
          } else if (action.action === "create-sale") {
            await this.$http
              .post("/sale/createx", {
                id: this.tempContract.sale_id,
                field: "status",
                value: "Cancelado",
                action: "cancel-sale",
                module: "sale",
                description: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name} cancelou a venda #${this.tempContract.sale_id}.`,
                modified_by: {
                  name: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}`,
                  id: this.$store.state.userData.id,
                },
              })
              .then(() => (action.done = true));
          } else if (action.action === "create-note-contract") {
            await this.$http
              .post("/note/create", {
                module_id: this.tempContract.id,
                module: "contract",
                reason: "Apenas para Registrar",
                user_id: this.$store.state.userData.id,
                content: `Este contrato foi ${
                  this.formatActionName().text
                } por <b>${this.$store.state.userData.first_name} ${
                  this.$store.state.userData.last_name
                }</b> em Aditivo de Vendas.`,
              })
              .then(() => (action.done = true));
          }
        } catch (error) {
          this.$message.error(`Erro ao executar ação: ${action.action}`);
          break; // Stop further actions if any error occurs
        } finally {
          action.loading = false;
        }
      }
    },
    async createCreditLetter() {
      this.loadingSubmit = true;

      try {
        const { data } = await this.$http.post("/credit-letter/createx", {
          user_id: this.$store.state.userData.id,
          company_id: this.tempContract.company_id,
          company_branch_id: this.tempContract.company_branch_id,
          customer_id: this.tempContract.customer_id,
          issuer_id: 0,
          supplier_id: 0,
          voyage_id: 0,
          product_type: "",
          currency: "brl",
          value: this.productTotalValue,
          profit_value: 0,
          available_value: this.productTotalValue,
          spent_value: 0,
          status: "active",
          supplier_status: "",
          supplier_value: 0,
          miles_status: 0,
          expires_at: "",
          receipt_date: "",
          modified_by: {
            name: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}`,
            id: this.$store.state.userData.id,
          },
        });

        this.$message.success("Carta de crédito criada com sucesso!");

        await this.$http.post("/log/createx", {
          user_id: this.$store.state.userData.id,
          module_id: this.tempContract.id,
          module: "contract",
          action: "cancel-mode-update-travelers-locator",
          description: `<b>[ADITIVO DE VENDAS]</b> ${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name} criou uma nova carta de crédito ID ${data.id}.`,
        });

        await this.$http.post("/log/createx", {
          user_id: this.$store.state.userData.id,
          module_id: data.id,
          module: "credit-letter",
          action: "create",
          description: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name} criou uma nova carta de crédito ID ${data.id}.`,
        });
      } catch (error) {
        console.error("Error creating credit letter:", error);
        this.$message.error("Ocorreu um erro ao criar a carta de crédito.");
      } finally {
        this.loadingSubmit = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.action-list {
  color: #333;
  font-weight: 500;
  font-size: 13px;
  .item {
    .box {
      font-size: 13px;
      position: relative;
      top: -2px;
      border: 2px solid #ddd;
      width: 22px;
      height: 22px;
      line-height: 24px;
      border-radius: 5px;
    }

    .check {
      color: #00aa21;
      background: #e8ffec;
    }
  }
}
</style>